export default __webpack_public_path__ + "static/media/faq_arrow.62cd43fe.svg";